import { FC, ReactNode } from 'react';
import { IonButton } from '@ionic/react';
import { useBreakpoints } from '../theme/useBreakpoints';

interface ISlideButtonProps {
    onClick: () => void;
    disabled?: boolean;
    children: ReactNode;
}

export const SlideButton: FC<ISlideButtonProps> = ({ onClick, disabled, children }) => {
    const { isBelowBreakpoint } = useBreakpoints();
    const padding = isBelowBreakpoint('sm') ? '0' : '0 50px';

    return (
        <IonButton expand="block" style={{padding, '--border-radius': '16px'}} disabled={disabled} onClick={onClick}>
            {children}
        </IonButton>
    );
};
